import {StyleSheet} from 'react-native';

import platformConfig from '/config/platform.config';
import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {alto, darkRed, wineRed} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    padding: 12,
  },
  container: {
    borderColor: alto,
    borderWidth: 1,
    width: '91%',
    borderRadius: 4,
    marginLeft: indent * 1,
  },
  accordionHeader: {
    backgroundColor: white,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: indent * 0.1,
  },
  alertButtonIcon: {
    fontSize: 18,
    fontWeight: '700',
    color: wineRed,
    marginRight: indent * 0.5,
  },
  accordionTitle: {
    fontWeight: platformConfig.select({ios: '700', android: 'bold'}),
  },
  accordionIcon: {
    position: 'absolute',
    paddingTop: 1,
    right: indent * 0.1,
  },
  accordionBody: {
    paddingTop: indent * 0.1,
    marginLeft: indent * 0.1,
    marginHorizontal: indent * 0.2,
    marginTop: indent * 0.2,
  },
  accordionBodyContent: {
    backgroundColor: white,
    flexDirection: 'row',
    marginBottom: indent * 0.3,
    paddingVertical: indent * 0.1,
    marginLeft: indent * 0.1,
  },
  declineButton: {
    flexDirection: 'row',
    alignItems: 'center',
    fontWeight: '400',
    marginTop: indent * 0.5,
    height: 40,
    marginBottom: indent * 0.5,
  },
  trashIcon: {
    color: wineRed,
    fontSize: 16,
    fontWeight: '500',
    marginLeft: 14,
    marginRight: 6,
  },
  declineLabel: {
    color: darkRed,
    fontSize: 14,
    ...getFontFamily('bold'),
    paddingLeft: indent * 0.1,
  },
  acceptButton: {
    justifyContent: 'center',
    width: '100%',
    borderRadius: indent * 0.4,
    marginTop: indent,
    marginBottom: indent * 0.5,
    height: 40,
    color: white,
    fontWeight: '900',
  },
  textContainer: {
    marginTop: indent * 0.4,
    fontSize: 16,
    marginLeft: 10,
  },
});
